import { render, staticRenderFns } from "./StartNewsItem.vue?vue&type=template&id=aa6907e6&scoped=true&"
import script from "./StartNewsItem.vue?vue&type=script&lang=ts&"
export * from "./StartNewsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6907e6",
  null
  
)

export default component.exports